import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CmsFacade } from '@rd/cms/facades/cms.facade';
import { ENV, TENANT_NAME } from '@rd/core/tokens/rd-lib.token';
import { Locale } from '@rd/types';
import { CmsPageContentType, FullPage } from '@rd/types/cms.type';
import { isNotNull } from '@rd/utils/isNotNull';
import { AnzEnvironmentType } from 'global-types';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'anz-campaign-variant1-page',
  templateUrl: './campaign-page-variant1.component.html',
  styleUrls: ['./campaign-page-variant1.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AnzCampaignPageVariant1Component implements OnInit {
  private cmsFacade = inject(CmsFacade);

  currentLocale$: Subscription;
  currentLocale: Locale;
  campaignPage: FullPage;
  showPage: boolean;
  variant: string;
  routeSubscription: Subscription;
  @ViewChild(MatExpansionPanel) matExpansionPanelElement: MatExpansionPanel;

  constructor(
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    @Inject(TENANT_NAME) private tenantName: string,
    @Inject(ENV) private env: AnzEnvironmentType,
  ) {}

  ngOnInit(): void {
    this.routeSubscription = this.route.data
      .pipe(untilDestroyed(this))
      .subscribe((routeData: any | undefined) => {
        this.getCampaignPage(routeData?.partnerId);
      });
  }

  private getCampaignPage(partnerId: string): void {
    this.cmsFacade
      .getContentByName({
        pageName: `${this.tenantName}--campaign-page-variant1-${partnerId}`,
        pageType: 'campaignpage-variant1',
        locale: 'en-au',
      })
      .pipe(untilDestroyed(this), filter(isNotNull))
      .subscribe((campaignPage: CmsPageContentType) => {
        if (campaignPage.type === 'campaignpage-variant1') {
          this.campaignPage = campaignPage;
          // We should rename showPage flag to showPageInProduction
          // We will do this later as this affect the campaigns in production
          this.showPage =
            this.env === 'production' ? this.campaignPage.showPage : true;
          this.cdr.markForCheck();
        }
      });
  }
}
